import React, { useState } from 'react'
import logo from '~images/jpmorgan_logo.png'
import shareImg from '~images/share_throng.png'
import './InfoSection.scss'
import { useHistory } from 'react-router-dom'
import { Icon } from '@connectcore/connect-components-react'

const InfoSection = () => {
  const [showFullContent, setShowFullContent] = useState(false)
  const history = useHistory()

  const handleLogoClick = () => {
    if (history.location.pathname === '/') {
      location.reload()
    } else {
      history.push('/')
    }
  }

  const info = () => {
    return (
      <div className="info" data-testid="info">
        <img src={shareImg} alt="share@jpmchase logo" onClick={() => handleLogoClick()} />
        <h1 className="mt-0">Secure Content Delivery</h1>
        <p>
          Welcome to JPMorgan Chase & Co.&apos;s secure file sharing portal, which can be used to
          securely download and upload files. The registration process consists of four simple steps
          to validate your email and phone number. Once completed, you&apos;ll be able to securely
          upload and share your files.
        </p>
        <p>
          The secure file sharing portal is just one of the ways JPMorgan Chase & Co. is committed
          to providing you the best client experience, saving your time, and providing you peace of
          mind.
        </p>
      </div>
    )
  }

  return (
    <div className="info-section col-12 col-md-6" data-testid="InfoSection">
      <div className="mobile-view">
        <div className="row">
          <Icon
            className="p-0 col-2"
            name="hamburger-menu"
            actionable
            onClick={() => {
              setShowFullContent(!showFullContent)
            }}
          />
          <img
            className="col-10 logo"
            src={logo}
            alt="JP Morgan Chase logo"
            onClick={() => handleLogoClick()}
          />
        </div>
        {showFullContent && info()}
      </div>
      <div className="desktop-view">
        <img
          src={logo}
          className="logo"
          alt="JP Morgan Chase logo"
          onClick={() => handleLogoClick()}
        />
        {info()}
      </div>
    </div>
  )
}

export default InfoSection
